// Лента отзывов: горизонтальная прокрутка со стрелками.
//
// Тема несёт свой slider-component, но он считает ширину слайдов один раз при
// инициализации и, если в этот момент вёрстка ещё не применилась, получает
// нулевой шаг — счётчик уходит в NaN, а стрелки остаются disabled навсегда.
// Здесь всё меряется в момент клика и на скролле, поэтому порядок загрузки
// стилей значения не имеет.
class VoicesRow extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-voices-track]');
    this.nav = this.querySelector('[data-voices-nav]');
    this.prev = this.querySelector('[data-voices-prev]');
    this.next = this.querySelector('[data-voices-next]');

    // Сворачивание — до проверки стрелок: при одном отзыве стрелок в разметке
    // нет, а длинный текст всё равно обрезан и без кнопки не раскрывается.
    this.setupCollapse();

    if (!this.track || !this.nav || !this.prev || !this.next) return;

    this.prev.addEventListener('click', () => this.scrollByCard(-1));
    this.next.addEventListener('click', () => this.scrollByCard(1));
    this.track.addEventListener('scroll', () => this.syncButtons(), { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(() => this.syncButtons()).observe(this.track);
    } else {
      window.addEventListener('resize', () => this.syncButtons(), { passive: true });
    }

    this.syncButtons();
  }

  // ── сворачивание длинных отзывов ──
  // Кнопка спрятана в разметке и появляется, только если текст правда не
  // поместился в отведённые строки. Меряем после раскладки и повторяем на
  // ресайзе и после загрузки шрифта: Mundial подгружается с Typekit, и до
  // его подмены высота текста другая.
  setupCollapse() {
    this.collapsibles = Array.prototype.slice.call(this.querySelectorAll('[data-voice-more]'));
    if (!this.collapsibles.length) return;

    this.collapsibles.forEach((button) => {
      var card = button.closest('.voice');
      if (!card) return;

      button.addEventListener('click', () => {
        var expanded = card.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        button.textContent = expanded
          ? button.getAttribute('data-less-label')
          : button.getAttribute('data-more-label');
      });
    });

    this.syncCollapse();

    if ('ResizeObserver' in window) {
      new ResizeObserver(() => this.syncCollapse()).observe(this);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => this.syncCollapse());
    }
  }

  syncCollapse() {
    if (!this.collapsibles) return;

    this.collapsibles.forEach((button) => {
      var card = button.closest('.voice');
      var text = card && card.querySelector('[data-voice-text]');
      if (!text) return;

      if (card.classList.contains('is-expanded')) {
        button.hidden = false;
        return;
      }

      // Пара пикселей запаса на округление при дробном масштабе.
      var clipped = text.scrollHeight > text.clientHeight + 2;

      // Класс включает градиент внизу текста. Без него короткому отзыву
      // гасило бы последнюю строку, хотя прятать нечего.
      card.classList.toggle('is-clamped', clipped);
      button.hidden = !clipped;
    });
  }

  // Шаг — ширина карточки плюс промежуток, снятые с живой разметки.
  // Берём самое короткое расстояние между соседними карточками: там, где
  // между ними стоит черта блокнотов, оно длиннее обычного.
  step() {
    const cards = this.track.querySelectorAll('[data-voices-card]');
    if (cards.length > 1) {
      let delta = 0;
      for (let i = 1; i < cards.length; i++) {
        const d = cards[i].offsetLeft - cards[i - 1].offsetLeft;
        if (d > 0 && (delta === 0 || d < delta)) delta = d;
      }
      if (delta > 0) return delta;
    }
    if (cards.length === 1 && cards[0].offsetWidth > 0) return cards[0].offsetWidth;
    return this.track.clientWidth;
  }

  scrollByCard(direction) {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.track.scrollBy({
      left: this.step() * direction,
      behavior: reduced ? 'auto' : 'smooth',
    });
  }

  syncButtons() {
    const max = this.track.scrollWidth - this.track.clientWidth;
    // Полпикселя запаса: дробное масштабирование не даёт scrollLeft
    // дойти до max ровно.
    const atStart = this.track.scrollLeft <= 0.5;
    const atEnd = this.track.scrollLeft >= max - 0.5;

    this.prev.disabled = atStart;
    this.next.disabled = atEnd;
    // Листать нечего — прячем стрелки, чтобы они не обещали продолжения,
    // которого нет. Прячем именно их, а не всю секцию.
    this.nav.hidden = max <= 0.5;
  }
}

if (!customElements.get('voices-row')) {
  customElements.define('voices-row', VoicesRow);
}
